import { createTheme } from "@mui/material/styles";

/** Tema MUI monocromo (negro / blanco) alineado con el shell TailAdmin */
const muiTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#101828",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#344054",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f9fafb",
      paper: "#ffffff",
    },
    text: {
      primary: "#101828",
      secondary: "#667085",
    },
    divider: "#e4e7ec",
  },
  typography: {
    fontFamily: '"Outfit", "Helvetica", "Arial", sans-serif',
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
        containedPrimary: {
          backgroundColor: "#101828",
          "&:hover": { backgroundColor: "#000000" },
        },
        outlinedPrimary: {
          borderColor: "#d0d5dd",
          color: "#101828",
          "&:hover": {
            borderColor: "#101828",
            backgroundColor: "#f9fafb",
          },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 500,
          "&.Mui-selected": {
            backgroundColor: "#101828",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#000",
            },
          },
        },
      },
    },
  },
});

export default muiTheme;
